import { render, staticRenderFns } from "./IntegerChangeIndicator.vue?vue&type=template&id=c0531ba4"
import script from "./IntegerChangeIndicator.vue?vue&type=script&lang=js"
export * from "./IntegerChangeIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports